module.exports = __webpack_public_path__ + "img/1-1.e43d9f09.png";